<template>
    <div
          class="modal right fade addnew-cusip"
          id="addcusip"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{cusipObj.id ? "EDIT" : "ADD"}}  CUSIP </h5>
              <button type="button" class="close" aria-label="Close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-row">
                  <div class="form-group col required">
                    <label for="inputEmail4">CUSIP</label>
                    <input
                      type="text"
                      :disabled="cusipObj.id"
                      @input="cusipObj.cusip=$event.target.value.toUpperCase()"
                      class="form-control"
                      v-model="cusipObj.cusip"
                      placeholder="Enter Cusip"
                      maxlength="9"
                    />
                  </div>
                  <div class="form-group col required">
                    <label for="exampleFormControlTextarea1">Description</label>
                    <textarea class="form-control" v-model="cusipObj.description" rows="2" maxlength="450"></textarea>
                  </div>
                  
                </div>
                <div class="form-row">
                  <div class="form-group col required">
                    <label for="inputPassword4">Coupon %</label>
                    <!-- <span class="input-group-text days per" id="basic-addon2">%</span> -->
                    <input
                      type="number"
                      class="form-control"
                      v-model="cusipObj.coupon"
                      placeholder="Enter Coupon"
                      maxlength="5"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    />
                  </div>
                 <div class="form-group col required">
                    <label for="inputPassword4">Product</label>
                    <select class="form-control" id="exampleFormControlSelect1"  v-model="cusipObj.offeringTypeId">
                      <option value>Please select</option>
                      <option value="1">MUNICIPAL</option>
                      <option value="2">CORPORATE</option>                  
                    </select>
                  </div>
                    <div class="form-group col">
                    <label for="inputEmail4">Call Date</label>
                    <datepicker v-model="cusipObj.callDate" placeholder="mm/dd/yyyy" typeable name="callDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="form-group col required right">
                    <label for="inputPassword4">Maturity Date</label>
                    <datepicker v-model="cusipObj.maturityDate" placeholder="mm/dd/yyyy" typeable name="maturitydate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col required">
                    <label for="inputEmail4">State</label>
                    <select class="form-control" id="exampleFormControlSelect1"  v-model="cusipObj.stateId">
                      <option value>Please select</option>
                      <option value="0">No State</option>
                      <option
                      v-for="state in stateConstants"
                      :key="state.id"
                      v-bind:value="state.id"
                    >{{state.name}}</option>
                    </select>
                  </div>
                  <div class="form-group col">
                    <label for="inputPassword4">Bond Insurer</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="cusipObj.bondInsurer"
                      placeholder="Enter Bond Insurer"
                      maxlength="450"
                    />
                  </div>
                  <div class="form-group col">
                    <label for="inputEmail4">S&P Rating</label>
                    <select class="form-control" id="exampleFormControlSelect1"  v-model="cusipObj.ratingSP">
                      <option value>Please select</option>
                      <option
                      v-for="sp in spRatingConstants"
                      :key="sp"
                      v-bind:value="sp"
                    >{{sp}}</option>
                    </select>
                  </div>
                  <div class="form-group col">
                    <label for="inputPassword4">Moody's Rating</label>
                    <select class="form-control" id="exampleFormControlSelect1"  v-model="cusipObj.ratingMoody">
                      <option value>Please select</option>
                      <option
                      v-for="moody in moodyConstants"
                      :key="moody"
                      v-bind:value="moody.toUpperCase()"
                    >{{moody}}</option>
                    </select>
                  </div>
                </div>
                <h5 v-if="cusipObj.isSecurityMasterExist" style="float:left">Security Master Fields</h5>
                <hr>
                <div  v-if="cusipObj.isSecurityMasterExist" class="form-row">
                  <div class="form-group col">
                    <label for="inputEmail4">Debit Interest Rate</label>
                    <input
                        type="number"
                        class="form-control"
                        v-model="cusipObj.debtInterestRate"
                      />
                  </div>
                  <div class="form-group col">
                    <label for="inputPassword4">Bid Price</label>
                    <input
                        type="number"
                        class="form-control"
                        v-model="cusipObj.bidPrice"
                      />
                  </div>
                  <div class="form-group col">
                    <label for="inputPassword4">Ask Price</label>
                    <input
                        type="number"
                        class="form-control"
                        v-model="cusipObj.askPrice"
                      />
                  </div>
                  <div class="form-group col right">
                    <label for="inputPassword4">Callable Date</label>
                    <datepicker v-model="cusipObj.callableDate" placeholder="mm/dd/yyyy" typeable name="callableDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                </div>
                <div  v-if="cusipObj.isSecurityMasterExist" class="form-row">
                  <div class="form-group col">
                    <label for="inputEmail4">Mand Put Date</label>
                    <datepicker v-model="cusipObj.mandatoryPutDate" placeholder="mm/dd/yyyy" typeable name="mandatoryPutDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="form-group col">
                    <label for="inputPassword4">Mand Put Price</label>
                    <input
                        type="number"
                        class="form-control"
                        v-model="cusipObj.mandatoryPutPrice"
                      />
                  </div>
                  <div class="form-group col">
                    <label for="inputPassword4">Next Call Date</label>
                    <datepicker v-model="cusipObj.nextCallDate" placeholder="mm/dd/yyyy" typeable name="nextCallDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                   <div class="form-group col">
                    <label for="inputPassword4">Next Call Price</label>
                    <input
                        type="number"
                        class="form-control"
                        v-model="cusipObj.nextCallPrice"
                      />
                  </div>
                </div>
                <div  v-if="cusipObj.isSecurityMasterExist" class="form-row">
                  <div class="form-group col">
                    <label for="inputEmail4">First Par Call Date</label>
                    <datepicker v-model="cusipObj.firstParCallDate" placeholder="mm/dd/yyyy" typeable name="firstParCallDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="form-group col">
                    <label for="inputPassword4">First Par Call Price</label>
                    <input
                        type="number"
                        class="form-control"
                        v-model="cusipObj.firstParCallPrice"
                      />
                  </div>
                  <div class="form-group col">
                    <label for="inputPassword4">Next Put Date</label>
                    <datepicker v-model="cusipObj.nextPutDate" placeholder="mm/dd/yyyy" typeable name="nextPutDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                   <div class="form-group col">
                    <label for="inputPassword4">Next Put Price</label>
                    <input
                        type="number"
                        class="form-control"
                        v-model="cusipObj.nextPutPrice"
                      />
                  </div>
                </div>
                <div  v-if="cusipObj.isSecurityMasterExist" class="form-row">
                  <div class="form-group col ">
                    <label for="inputPassword4">Offering Type</label>
                    <select class="form-control" id="exampleFormControlSelect1"  v-model="cusipObj.offeringTypeId">
                      <option value>Please select</option>
                      <option value="1">Munis</option>
                      <option value="2">Corporates</option>                  
                    </select>
                  </div>
                  <div class="form-group col ">
                    <label for="inputPassword4">Redemption Type</label>
                    <select class="form-control" id="exampleFormControlSelect1"  v-model="cusipObj.redemptionType">
                      <option value>Please select</option>
                      <option value="P">P</option>
                      <option value="E">E</option>                  
                    </select>
                  </div>
                </div>
                
              </form>
            </div>
            <div v-if="cusipLoading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
             <p v-if="cusipValidationErrors.length">
                <ul>
                  <li class="alert alert-danger" role="alert" v-for="error in cusipValidationErrors" v-bind:key="error">{{ error }}</li>
                </ul>
              </p>
            <div class="modal-footer bid">
              <button type="button" class="btn btn-secondary" @click="$emit('close')">CANCEL</button>
              <button v-if="!cusipObj.id" type="button" class="btn btn-primary" @click="addCusip()">ADD CUSIP</button>
              <button v-if="cusipObj.id" type="button" class="btn btn-primary" @click="updateCusip()">UPDATE CUSIP</button>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import stateConstants from "@/stateConstants";
import moodyConstants from "@/moodyRatingConstants";
import spRatingConstants from "@/spRatingConstants";
import config from "@/config";
import Datepicker from 'vuejs-datepicker';
import authService from "@/authService";

export default {
  name: "trader-addcusip",
   components: {
     Datepicker
  },
  props: ['addCusipObj'],
  data() {
    return {
        cusipValidationErrors:[],
        cusipLoading : false,
        moodyConstants:moodyConstants,
        spRatingConstants:spRatingConstants,
        stateConstants: stateConstants,
        cusipObj : {}
    };
  },
  methods: {
    addCusip() {
      let isValid = this.checkForm();
      if (isValid) {
       // this.cusipObj.stateId = "" + this.cusipObj.stateId;
        this.cusipLoading = true;
        var addData = { ...this.cusipObj};
        addData.coupon = parseFloat(addData.coupon / 100);
        addData.callDate = addData.callDate ? this.moment(addData.callDate).format("MM/DD/YYYY") : null;            
        addData.maturityDate = addData.maturityDate ? this.moment(addData.maturityDate).format("MM/DD/YYYY") : null;               
        addData.mandatoryPutDate = addData.mandatoryPutDate ? this.moment(addData.mandatoryPutDate).format("MM/DD/YYYY") : null;               
        addData.callableDate = addData.callableDate ? this.moment(addData.callableDate).format("MM/DD/YYYY") : null;               
        addData.firstParCallDate = addData.firstParCallDate ? this.moment(addData.firstParCallDate).format("MM/DD/YYYY") : null;               
        addData.nextPutDate = addData.nextPutDate ? this.moment(addData.nextPutDate).format("MM/DD/YYYY") : null;
        const auth = {
          headers: {  }
        };

        this.$http
          .post(config.baseUrlBidSide + "/cusip", addData, auth)
          .then(() => {
            this.cusipLoading = false;              
            this.$emit('close');               
          })
          .catch(e => {
            console.log(e.response);
            if(e.response.data == "Duplicate CUSIP"){
              this.$alert("This Cusip already exists.");
            }
            this.cusipLoading = false;              

           // this.errors.push(e.response.data);
          });
      }
    },
    updateCusip() {
      let isValid = this.checkForm();
      if (isValid) {
       // this.cusipObj.stateId = "" + this.cusipObj.stateId;
        this.cusipLoading = true;
        var updateData = { ...this.cusipObj};
        updateData.coupon = parseFloat(updateData.coupon / 100);
        updateData.callDate = updateData.callDate ? this.moment(updateData.callDate).format("MM/DD/YYYY") : null;            
        updateData.maturityDate = updateData.maturityDate ? this.moment(updateData.maturityDate).format("MM/DD/YYYY") : null;               
        updateData.mandatoryPutDate = updateData.mandatoryPutDate ? this.moment(updateData.mandatoryPutDate).format("MM/DD/YYYY") : null;               
        updateData.callableDate = updateData.callableDate ? this.moment(updateData.callableDate).format("MM/DD/YYYY") : null;               
        updateData.firstParCallDate = updateData.firstParCallDate ? this.moment(updateData.firstParCallDate).format("MM/DD/YYYY") : null;               
        updateData.nextPutDate = updateData.nextPutDate ? this.moment(updateData.nextPutDate).format("MM/DD/YYYY") : null;               
        const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
          .put(config.baseUrlBidSide + "/cusip", updateData, auth)
          .then(() => {
            this.cusipLoading = false;              
            this.$emit('close');                  
          })
          .catch(e => {
            console.log(e.response);
            this.cusipLoading = false;              
          });
      }
    },
    checkForm: function() {

      this.cusipValidationErrors = [];
      if (!this.cusipObj.cusip) {
        this.cusipValidationErrors.push("Cusip number is required.");
        return false;
      }
      if (this.cusipObj.cusip.length != 9) {
        this.cusipValidationErrors.push("Enter 9 digit characters long  CUSIP");
        return false;
      }
      if (!this.cusipObj.coupon) {
        this.cusipValidationErrors.push("Coupon is required.");
        return false;
      }
       if (this.cusipObj.coupon > 100) {
        this.cusipValidationErrors.push("Coupon should be less than 100.");
        return false;
      }
      if (!this.cusipObj.description) {
        this.cusipValidationErrors.push("Description is required.");
        return false;
      }
      // if (!this.cusipObj.callDate) {
      //   this.cusipValidationErrors.push("Call date is required.");
      //   return false;
      // }
      if (!this.cusipObj.offeringTypeId) {
        this.cusipValidationErrors.push("Product is required.");
        return false;
      }
      if (!this.cusipObj.maturityDate) {
        this.cusipValidationErrors.push("Maturity date is required.");
        return false;
      }
      console.log(this.cusipObj.callDate,this.cusipObj.maturityDate)
      if(this.cusipObj.callDate && this.moment(this.cusipObj.callDate).isAfter(this.cusipObj.maturityDate)){
        this.cusipValidationErrors.push("The Maturity date cannot be before the Call date.");
        return false;
      }
      if (!this.cusipObj.stateId) {
        this.cusipValidationErrors.push("State is required.");
        return false;
      }
      // if (!this.cusipObj.bondInsurer) {
      //   this.cusipValidationErrors.push("BondInsurer is required.");
      //   return false;
      // }
      // if (!this.cusipObj.ratingSP) {
      //   this.cusipValidationErrors.push("S&P rating is required.");
      //   return false;
      // }
      // if (!this.cusipObj.ratingMoody) {
      //   this.cusipValidationErrors.push("Moody's rating is required.");
      //   return false;
      // }
      
     return true;

    },
     getCusipDetails(){
        this.cusipObj = {};
        if(!this.addCusipObj.id){
          return false;
        }
        this.cusipLoading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
          config.baseUrlBidSide +
            "/cusip/"+this.addCusipObj.id,auth
        )
        .then((result) => {
          this.cusipLoading = false;
          this.cusipObj = result.data;
          this.cusipObj.coupon = (this.cusipObj.coupon * 100).toFixed(3);
          this.cusipObj.stateId = this.cusipObj.stateId ? this.cusipObj.stateId : '0';
          //this.cusipObj.callDate = this.cusipObj.callDate ? this.moment(this.cusipObj.callDate).format("MM/DD/YYYY") : "null";
          //this.cusipObj.maturityDate = this.cusipObj.maturityDate ?  this.moment(this.cusipObj.maturityDate).format("MM/DD/YYYY") : "null";
        })
      },
    
  },
  mounted() {
   this.getCusipDetails();
  }
};
</script>